/**
 * Place single semantic DOM into desktop buy column + description tab.
 * Mobile keeps nodes inside .ps (flex-order in section-product-semantic.css).
 *
 * Desktop desc-tab order:
 *   description → FAQ (H2) → Tags (nav, not heading) → Previous/Next → PDF
 */
(function () {
  var MQ = '(min-width: 750px)';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function placeDesktop() {
    var head = qs('.ps__head');
    var body = qs('.ps__body');
    var desc = qs('.ps__description');
    var faq = qs('.ps__faq');
    var tags = qs('.ps__tags');
    var pdf = qs('.ps__pdf');
    var info = qs('.product__info-container');
    var titleSlot = qs('.product__title--semantic-owned');
    var specSlot = qs('.product-spec-list-block--semantic-owned');
    var descSlot = qs('[data-ps-desc-slot]');
    var panel = qs('product-info .panel-group.detail-bottom');
    var pager = descSlot && qs('.product-vendor-pager', descSlot);

    if (!head || !info) return;

    if (titleSlot && titleSlot.parentNode === info) {
      titleSlot.before(head);
    } else if (head.parentNode !== info) {
      info.prepend(head);
    }

    var specs = qs('.ps__specs', head) || qs('.ps__specs');
    if (specSlot && specSlot.parentNode === info && specs) {
      specSlot.before(specs);
    }

    if (descSlot) {
      if (desc) descSlot.prepend(desc);
      if (faq) {
        if (desc) desc.after(faq);
        else descSlot.prepend(faq);
      }
      /* Tags directly after FAQ (before Previous/Next) */
      if (tags) {
        if (faq) faq.after(tags);
        else if (desc) desc.after(tags);
        else descSlot.appendChild(tags);
      }
      if (pdf) {
        if (pager) pager.after(pdf);
        else if (tags) tags.after(pdf);
        else descSlot.appendChild(pdf);
      }
    }

    if (panel) {
      panel.removeAttribute('hidden');
      panel.style.display = '';
    }

    if (body && !body.children.length) {
      body.setAttribute('hidden', '');
    } else if (body) {
      body.removeAttribute('hidden');
    }
  }

  function placeMobile() {
    var head = qs('.ps__head');
    var body = qs('.ps__body');
    var ps = qs('.ps');
    var desc = qs('.ps__description');
    var faq = qs('.ps__faq');
    var tags = qs('.ps__tags');
    var pdf = qs('.ps__pdf');
    var panel = qs('product-info .panel-group.detail-bottom');

    if (ps && head && head.parentNode !== ps) {
      ps.insertBefore(head, ps.firstChild);
    }
    if (ps && head) {
      var specs = qs('.ps__specs');
      if (specs && specs.parentNode !== head) head.appendChild(specs);
    }
    if (ps && body) {
      if (body.parentNode !== ps || (head && head.nextSibling !== body)) {
        if (head) head.after(body);
        else ps.appendChild(body);
      }
      body.removeAttribute('hidden');
      if (desc && desc.parentNode !== body) body.appendChild(desc);
      if (faq) {
        if (desc) desc.after(faq);
        else body.appendChild(faq);
      }
      if (tags) {
        if (faq) faq.after(tags);
        else if (desc) desc.after(tags);
        else body.appendChild(tags);
      }
      if (pdf) {
        if (tags) tags.after(pdf);
        else if (faq) faq.after(pdf);
        else body.appendChild(pdf);
      }
    }
    if (panel) {
      panel.removeAttribute('hidden');
      panel.style.display = '';
    }
  }

  function sync() {
    if (window.matchMedia(MQ).matches) placeDesktop();
    else placeMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.matchMedia(MQ).addEventListener('change', sync);
})();
